import { cloneDeep } from 'lodash'

import { getConvertedData } from '../../../../../../models/interface.helper'
import { getUserFullName } from '../../../../../../helpers/helpers'

import FirestoreService from '../../../../../../services/firestoreService'

import { ScoreCardModel } from '../../../../../../models/score-cards/score-cards.model'
import { RegistrationFeesModel } from '../../../../../../models/registration-fees/registrationFees.model'
import {
  IJudge,
  IRegistrationByDayInterface,
} from '../../../../../../models/registrations-by-day/registrationByDay.interface'
import { IScoreCardType } from '../../../../../../models/score-cards/score-cards.interface'
import {
  IScoreCardDiscipline,
  RegistrationFeesType,
} from '../../../../../../models/event-fees/event-fees.interface'
import { IUserInterface } from '../../../../../../models/users/user.interface'

import { dummySheets } from '../../data/sheets'

import { CONST } from '../../../../../../const/const'
import { EventFeesModel } from '../../../../../../models/event-fees/event-fees.model'

const COLLECTIONS = CONST.DATA.FIRESTORE.V01.COLLECTIONS

export const DUMMY_REGISTRATION_FEES_STATS = [
  { ...new RegistrationFeesModel(), loading: true },
  { ...new RegistrationFeesModel(), loading: true },
  { ...new RegistrationFeesModel(), loading: true },
  { ...new RegistrationFeesModel(), loading: true },
]

export const sortByOrder = (array: any[]) => {
  return array.sort((a, b) => {
    if (a.order === 0 && b.order === 0) {
      return 0
    }
    if (a.order === 0) {
      return 1
    }
    if (b.order === 0) {
      return -1
    }
    return a.order - b.order
  })
}

export const sortByTotalPoints = (array: IRegistrationByDayInterface[], direction = 'desc') => {
  return array.sort((a, b) => {
    const totalPointsA = Number(a.score?.totalPoints || 0)
    const totalPointsB = Number(b.score?.totalPoints || 0)

    if (totalPointsA === 0 && totalPointsB === 0) {
      return 0
    }
    if (totalPointsA === 0) {
      return 1
    }
    if (totalPointsB === 0) {
      return -1
    }
    return direction === 'asc' ? totalPointsA - totalPointsB : totalPointsB - totalPointsA
  })
}

export const getJudgesAndSheet = async ({
  discipline,
  sheetId,
  judgeIds,
  users,
}: {
  discipline: IScoreCardDiscipline
  sheetId?: string
  judgeIds: string[]
  users: IUserInterface[]
}) => {
  const judges: IJudge[] = []
  let sheet: { name: string; type: IScoreCardType } = { name: '', type: null }

  if (discipline === 'Dressage') {
    const current = dummySheets.find((current) => current.id === sheetId)
    judgeIds?.forEach((judge) => {
      const user = users.find((user) => user.id === judge)

      judges.push({
        id: judge,
        name: user ? getUserFullName(user) : 'N/A',
        picture: user?.userProfilePicture || '',
        furtherRemarks: cloneDeep(current?.furtherRemarks) || '',
        sections: cloneDeep(current?.sections) || [],
        customSections: [],
        errors: cloneDeep(current?.errors) || 0,
        signatureDate: null,
        signatureUrl: null,
      })
    })

    sheet = {
      name: current?.name ?? '',
      type: (current?.type as IScoreCardType) ?? null,
    }
  }
  if (discipline === 'Hunter Jumper' && sheetId) {
    const scoreCardSnaps = await FirestoreService.getItem(COLLECTIONS.SCORE_CARDS.NAME, sheetId)
    const current = getConvertedData(ScoreCardModel.fromFirestoreDoc(scoreCardSnaps).toObject())
    judgeIds?.forEach((judge) => {
      const user = users.find((user) => user.id === judge)

      judges.push({
        id: judge,
        name: user ? getUserFullName(user) : 'N/A',
        picture: user?.userProfilePicture ?? '',
        furtherRemarks: current.furtherRemarks,
        sections: [],
        customSections: current?.sections ?? [],
        isWithdrew: current.isWithdrew,
        showJumpOff: current.showJumpOff,
        fenceHeight: current.fenceHeight,
        signatureDate: null,
        signatureUrl: null,
      })
    })

    sheet = {
      name: current?.name ?? '',
      type: current?.type ?? null,
    }
  }

  return { judges, sheet }
}

export const getRegistrationFee = (
  registrationFees: RegistrationFeesType[],
  uuid: string,
  parentId?: string
) => {
  let current: RegistrationFeesType = new EventFeesModel().registrationFees[0]

  if (parentId) {
    const parentIndex = registrationFees?.findIndex(
      (item: RegistrationFeesType) => item.uuid === parentId
    )
    registrationFees[parentIndex]?.children?.forEach((registrationFee: RegistrationFeesType) => {
      if (registrationFee.uuid === uuid) {
        current = registrationFee
      }
    })
  } else {
    registrationFees?.forEach((registrationFee: RegistrationFeesType) => {
      if (registrationFee.uuid === uuid) current = registrationFee
    })
  }

  return current
}
